import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import withTranslate from '../../hoc/with-translate';
import styles from './like-button.scss';

class LikeButton extends Component {
  state = {
    isAnimationEnabled: false,
  };

  constructor(props) {
    super(props);

    this.handleAnimation = this.handleAnimation.bind(this);
  }

  handleAnimation(event) {
    if (this.props.isDisabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    if (!this.props.isLiked) {
      this.setState({ isAnimationEnabled: true });
    }
  }

  render() {
    const { isLiked, likeCount, t } = this.props;
    const { isAnimationEnabled } = this.state;
    const likedStatusLabel = isLiked ? t('like-button.is-liked') : t('like-button.is-unliked');

    return (
      <div
        onClick={this.handleAnimation}
        className={classNames(
          styles.heart,
          { [styles.active]: isLiked },
          { [styles.isAnimationEnabled]: isAnimationEnabled }
        )}
        aria-label={`${t('like-button.total-likes', { count: likeCount })} ${likedStatusLabel}`}
        data-hook="like-button"
      >
        <div className={classNames(styles.pos1)}>
          <div className={classNames(styles.heartSparkle)}/>
        </div>
        <div className={classNames(styles.pos2)}>
          <div className={classNames(styles.heartSparkle)}/>
        </div>
        <div className={classNames(styles.pos3)}>
          <div className={classNames(styles.heartSparkle)}/>
        </div>
        <div className={classNames(styles.pos4)}>
          <div className={classNames(styles.heartSparkle)}/>
        </div>
        <div className={classNames(styles.heartRing)}/>
        <svg className={classNames(styles.heartBody)} width="18" viewBox="0 0 18 16">
          <path
            d="M314,262.364a4.309,4.309,0,0,0-8-2.279,4.309,4.309,0,0,0-8,2.279,4.366,4.366,0,0,0,1.483,3.286l6.123,6.185a0.553,0.553,0,0,0,.788,0l6.123-6.185A4.366,4.366,0,0,0,314,262.364Z"
            transform="translate(-297.25 -257.25)"
          />
        </svg>
      </div>
    );
  }
}

LikeButton.propTypes = {
  isLiked: PropTypes.bool,
  likeCount: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslate(LikeButton);



// WEBPACK FOOTER //
// ./app/components/like-button/like-button.js